import { Avatar } from '@mantine/core';

import { ContactKind } from 'src/Services/API/generated';
import {
  getBrandfetchLogoUrl,
  getCompanyLogoDomain,
  getNameInitials,
} from 'src/Utils/companyLogoDomain';

import styles from './ContactAvatar.module.scss';
import { Props } from './ContactAvatar.types';

const ContactAvatar = ({ name, kind, imageUrl, websiteUrl, emails, size }: Props) => {
  if (imageUrl) {
    return (
      <img
        src={imageUrl}
        className={styles.picture}
        style={{ width: size, height: size }}
        alt={name}
      />
    );
  }

  // Never a logo for a person: their email domain says nothing about them.
  const domain =
    kind === ContactKind.Company ? getCompanyLogoDomain({ websiteUrl, emails }) : undefined;

  // Brandfetch answers 404 when it has no logo, and Avatar then falls back to the initials.
  return (
    <Avatar
      src={domain ? getBrandfetchLogoUrl(domain) : undefined}
      size={size}
      alt={name}
      className={domain ? styles.logo : undefined}
    >
      {getNameInitials(name)}
    </Avatar>
  );
};

export default ContactAvatar;
